// context/OrderContext.js
import React, { createContext, useContext, useState } from 'react';

const OrderContext = createContext();

export const OrderProvider = ({ children }) => {
    const [selectedClient, setSelectedClient] = useState(null);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [actionType, setActionType] = useState(null);
    const [useTarifPrices, setUseTarifPrices] = useState(false);
    const [selectedPriceListId, setSelectedPriceListId] = useState(null);

    const updateProduct = (id, field, value) => {
        setSelectedProducts((prev) =>
            prev.map((p) => (p.id === id ? { ...p, [field]: value } : p))
        );
    };

    const removeProduct = (id) => {
        setSelectedProducts((prev) => prev.filter((p) => p.id !== id));
    };

    const resetOrder = () => {
        setSelectedProducts([]);
        setActionType(null);
        setUseTarifPrices(false);
        setSelectedPriceListId(null);
    };

    return (
        <OrderContext.Provider
            value={{
                selectedClient,
                setSelectedClient,
                selectedProducts,
                setSelectedProducts,
                actionType,
                setActionType,
                updateProduct,
                removeProduct,
                resetOrder,
                useTarifPrices,
                setUseTarifPrices,
                selectedPriceListId,
                setSelectedPriceListId
            }}
        >
            {children}
        </OrderContext.Provider>
    );
};


export const useOrder = () => useContext(OrderContext);
